/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import 'mapbox-gl-leaflet';
import 'leaflet.gridlayer.googlemutant';
import 'leaflet-draw';
import 'leaflet-draw/dist/leaflet.draw.css';
import drawLocales from 'leaflet-draw-locales';
import styles from '../fields.module.scss';
import fstyles from '../../../modules/forms/components/attachments.module.scss';
import { uniqueID } from '../../../utils/helpers';
import * as utils from '../../../utils/mapUtils';
import icon from '../../../icons/formMarker.png';
import { CUSTOM_MAP, custom_map_max_zoom_level, get_custom_map_url, MAP_BOX } from '../../../constants/mapSettings';

const language = localStorage.getItem('lang') || 'en';
drawLocales(language !== 'az' ? language : 'en');

let locale = {};
if (language !== 'az') {
  locale = drawLocales(language);
  locale.draw.toolbar.buttons.polygon = 'Draw a New Surface!';
}
L.drawLocal = language === 'az' ? utils.azerbaijaniDrawLocale : locale;

class MultiLocation extends Component {
  ID = uniqueID('map');

  constructor(props) {
    super(props);
    this.mapContainerRef = React.createRef();
    this.state = {
      onlyDraw: false,
      onlyEdit: false,
      markers: [],
      polygons: [],
      polygonLines: []
    };
    this.defaultConfig = {
      marker: true,
      circle: false,
      rectangle: false,
      polyline: (props?.fromForms) === true,
      circlemarker: false,
      polygon: true
    };
    const { isRequired, updateFieldErrors, answer } = this.props;

    if (isRequired && (answer === '' || answer === undefined)) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
  }

  componentDidMount() {
    this.initializeMap();
  }

  componentDidUpdate(prevProps, prevState) {
    const { answer, isRequired, updateFieldErrors } = this.props;

    if (prevProps.answer !== answer) {
      this.updateMapFromAnswer(answer);
    }
    if (prevState.onlyDraw !== this.state.onlyDraw || prevState.onlyEdit !== this.state.onlyEdit) {
      this.updateDrawControls();
    }
    if (
      (answer === '' || answer === undefined || answer === null)
      && isRequired
      && prevProps.answer !== answer
    ) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
  }

  componentWillUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.invalidateFrame) {
      cancelAnimationFrame(this.invalidateFrame);
    }
    if (this.map) {
      this.map.remove();
    }
  }

  handleMarkReverse = initial => [initial[1], initial[0]]

  initializeMap = () => {
    const { airportInfo, onlyLocationView, fromForms, answer, allowMultiple } = this.props;
    const locationPoint = airportInfo.location;
    const curLocation = [locationPoint[1], locationPoint[0]];
    this.map = L.map(this.mapContainerRef.current, {
      center: curLocation,
      zoom: 15,
      editable: true,
      fullscreenControl: !!onlyLocationView,
      attributionControl: false
    });

    this.drawnItems = new L.FeatureGroup();
    this.map.addLayer(this.drawnItems);

    this.map.whenReady(() => {
      this.addBaseLayer();
      if (!this.props.disabled) {
        if (!fromForms) {
          this.addDrawControl();
        }
        if (fromForms && answer) {
          this.setState({ onlyEdit: true });
          if (!allowMultiple) {
            this.changeDrawControls();
          } else {
            this.addDrawControl();
          }
        } else {
          this.addDrawControl();
        }
      }
      this.map.on('draw:created', this.handleDrawCreated);
      this.map.on('draw:edited', this.handleDrawEdited);
      this.map.on('draw:deleted', this.handleDrawDeleted);
    });

    L.EditToolbar.Delete.include({
      removeAllLayers: false
    });
    this.updateMapFromAnswer(this.props.answer);
  };

  addBaseLayer = () => {
    const { airportInfo } = this.props;

    if (airportInfo.map_style === MAP_BOX) {
      L.mapboxGL({
        accessToken: process.env.REACT_APP_MAPBOX_TOKEN,
        style: airportInfo?.mapbox_style || 'mapbox://styles/mapbox/satellite-v9'
      }).addTo(this.map);
    } else if (airportInfo?.map_style === CUSTOM_MAP) {
      L.tileLayer(get_custom_map_url(airportInfo?.custom_map_url), {
        maxZoom: custom_map_max_zoom_level
      }).addTo(this.map);
    } else {
      L.gridLayer.googleMutant({ type: 'satellite', maxZoom: 20 }).addTo(this.map);
    }
  };

  addDrawControl = () => {
    const { fromForms, shape } = this.props;
    const CustomMarker = L.Icon.extend({
      options: {
        iconUrl: icon,
        iconSize: [29, 35],
        iconAnchor: [15, 35]
      }
    });

    const drawControl = new L.Control.Draw({
      editable: true,
      marker: false,
      edit: {
        featureGroup: this.drawnItems,
        remove: !fromForms,
        edit: !fromForms
      },
      draw: {
        ...this.defaultConfig,
        marker: shape && shape !== 'Point' ? false : { icon: new CustomMarker() },
        polygon: shape && shape !== 'Polygon' ? false
            : {
                shapeOptions: {
                  color: fromForms ? '#3388ff' : 'blue',
                  opacity: 1,
                  fillOpacity: 0.48
                },
                icon: new utils.CustomIcon({ color: fromForms ? '#3388ff' : 'blue' })
              },
        polyline: shape && shape !== 'LineString' ? false
            : { shapeOptions: {
                  color: fromForms ? '#3388ff' : 'blue',
                  opacity: 1,
                  fillOpacity: 0.48
                } },
        circle: false,
        rectangle: false,
        circlemarker: false
      }
    });

    const getShapeSpecificDrawOptions = () => ({
      ...this.defaultConfig,
      marker: shape && shape !== 'Point' ? false : { icon: new CustomMarker() },
      polygon:
        shape && shape !== 'Polygon' ? false
          : {
              shapeOptions: {
                color: fromForms ? '#3388ff' : 'blue',
                opacity: 1,
                fillOpacity: 0.48
              },
              icon: new utils.CustomIcon({ color: fromForms ? '#3388ff' : 'blue' })
            },
      polyline:
        shape && shape !== 'LineString' ? false
          : {
              shapeOptions: {
                color: fromForms ? '#3388ff' : 'blue',
                opacity: 1,
                fillOpacity: 0.48
              }
            },
      circle: false,
      rectangle: false,
      circlemarker: false
    });

    const onlyDrawControl = new L.Control.Draw({
      editable: true,
      marker: false,
      edit: {
        featureGroup: this.drawnItems,
        remove: !!fromForms,
        edit: !!fromForms
      },
      draw: getShapeSpecificDrawOptions()
    });

    const onlyEditControl = new L.Control.Draw({
      editable: true,
      marker: false,
      edit: {
        featureGroup: this.drawnItems,
        remove: true,
        edit: true
      },
      draw: getShapeSpecificDrawOptions()
    });

    this.setState({
      drawControl,
      onlyDrawControl,
      onlyEditControl
    });

    if (!this.state.onlyDraw && !this.state.onlyEdit) {
      this.map.addControl(drawControl);
    }
  };

  updateDrawControls = () => {
    const { drawControl, onlyDrawControl, onlyEditControl } = this.state;

    if (this.state.onlyDraw) {
      this.map.removeControl(drawControl);
      this.map.removeControl(onlyEditControl);
      this.map.addControl(onlyDrawControl);
    } else if (this.state.onlyEdit) {
      this.map.removeControl(onlyDrawControl);
      this.map.removeControl(drawControl);
      this.map.addControl(onlyEditControl);
    } else {
      this.map.removeControl(onlyDrawControl);
      this.map.removeControl(onlyEditControl);
      this.map.addControl(drawControl);
    }
  };

  changeDrawControls = () => {
    const { fromForms, allowMultiple, answer, shape } = this.props;
    if (this.state.drawControl) {
      this.map.removeControl(this.state.drawControl);
    }
    if (this.state.onlyDrawControl) {
      this.map.removeControl(this.state.onlyDrawControl);
    }
    if (this.state.onlyEditControl) {
      this.map.removeControl(this.state.onlyEditControl);
    }
    const CustomMarker = L.Icon.extend({
      options: {
        iconUrl: icon,
        iconSize: [29, 35],
        iconAnchor: [15, 35]
      }
    });

    // Determine which tools should be disabled
    let disableMarker = false;
    let disablePolygon = false;
    let disablePolyline = false;

    if (fromForms && !allowMultiple && answer) {
      disableMarker = !!answer.locations;
      disablePolygon = !!answer.polygons;
      disablePolyline = !!answer.polylines;
    }

    // Build draw options conditionally
    const drawOptions = {
      marker: (shape && shape !== 'Point') || disableMarker ? false : {
        icon: new CustomMarker()
      },
      polygon: (shape && shape !== 'Polygon') || disablePolygon ? false : {
        shapeOptions: {
          color: fromForms ? '#3388ff' : 'blue',
          opacity: 1,
          fillOpacity: 0.48
        },
        icon: new utils.CustomIcon({ color: fromForms ? '#3388ff' : 'blue' })
      },
      polyline: (shape && shape !== 'LineString') || disablePolyline ? false : {
        shapeOptions: {
          color: fromForms ? '#3388ff' : 'blue',
          opacity: 1,
          fillOpacity: 0.48
        }
      },
      circle: false,
      rectangle: false,
      circlemarker: false
    };

    // Define draw controls
    const drawControl = new L.Control.Draw({
      editable: true,
      marker: false,
      edit: {
        featureGroup: this.drawnItems,
        remove: !fromForms,
        edit: !fromForms
      },
      draw: drawOptions
    });

    const onlyDrawControl = new L.Control.Draw({
      editable: true,
      marker: false,
      edit: {
        featureGroup: this.drawnItems,
        remove: !!fromForms,
        edit: !!fromForms
      },
      draw: drawOptions
    });

    const onlyEditControl = new L.Control.Draw({
      editable: true,
      marker: false,
      edit: {
        featureGroup: this.drawnItems,
        remove: true,
        edit: true
      },
      draw: drawOptions
    });

    this.setState({
      drawControl,
      onlyDrawControl,
      onlyEditControl
    });

    if (this.state.onlyDraw) {
      this.map.removeControl(drawControl);
      this.map.removeControl(onlyEditControl);
      this.map.addControl(onlyDrawControl);
    } else if (this.state.onlyEdit) {
      this.map.removeControl(onlyDrawControl);
      this.map.removeControl(drawControl);
      this.map.addControl(onlyEditControl);
    } else {
      this.map.removeControl(onlyDrawControl);
      this.map.removeControl(onlyEditControl);
      this.map.addControl(drawControl);
    }
  }

  handleDrawCreated = (e) => {
    const { fromForms, allowMultiple } = this.props;
    const { layer } = e;
    if (layer instanceof L.Marker) {
      const location = [layer.getLatLng().lng, layer.getLatLng().lat];
      this.updateMarkers(location);
    } else if (layer instanceof L.Polygon) {
      const coordinates = layer.getLatLngs()[0].map(latlng => [latlng.lng, latlng.lat]);
      this.updatePolygons(coordinates);
    } else if (layer instanceof L.Polyline) {
      this.updatePolyLine(layer._latlngs.map(o => [o.lng, o.lat]));
    }
    if (fromForms && !allowMultiple) {
      this.setState({ onlyDraw: true }, () => {
        this.changeDrawControls();
      });
    } else {
      this.setState({ onlyDraw: true });
    }
  };

  handleDrawEdited = (e) => {
    e.layers.eachLayer((layer) => {
      if (layer instanceof L.Marker) {
        const location = [layer.getLatLng().lng, layer.getLatLng().lat];
        this.editMarkers(location, layer._leaflet_id);
      } else if (layer instanceof L.Polygon) {
        const coordinates = layer.getLatLngs()[0].map(latlng => [latlng.lng, latlng.lat]);
        this.editPolygons(coordinates, layer._leaflet_id);
      } else if (layer instanceof L.Polyline) {
        this.editPolygonLines(layer._latlngs.map(o => [o.lng, o.lat]), layer._leaflet_id);
      }
    });
    this.setState({ onlyEdit: true });
  };

  handleDrawDeleted = (e) => {
    const { fromForms, allowMultiple } = this.props;
    const deletedLayers = e.layers.getLayers();

    deletedLayers.forEach((layer) => {
      if (layer instanceof L.Marker) {
        const location = [layer.getLatLng().lng, layer.getLatLng().lat];
        this.removeMarker(location, layer._leaflet_id);
      } else if (layer instanceof L.Polygon) {
        const coordinates = layer
          .getLatLngs()[0]
          .map(latlng => [latlng.lng, latlng.lat]);
        this.removePolygon(coordinates, layer._leaflet_id);
      } else if (layer instanceof L.Polyline) {
        const coordinates = layer
          .getLatLngs()
          .map(latlng => [latlng.lng, latlng.lat]);
        this.removePolygonLine(coordinates, layer._leaflet_id);
      }
    });
    if (fromForms && !allowMultiple) {
      this.changeDrawControls();
    }
  };

  editMarkers = (location, layerId) => {
    const { markers } = this.state;
    const markerIndex = markers.findIndex(marker => marker.id === layerId);
    if (markerIndex !== -1) {
      const previousCoordinates = markers[markerIndex].coordinates;
      const updatedMarkers = [...markers];
      updatedMarkers[markerIndex] = { ...updatedMarkers[markerIndex], coordinates: location };
      this.setState({ markers: updatedMarkers });
      this.handleEditChanged(location, previousCoordinates, 'locations', 'Point');
    }
  };

  editPolygons = (coordinates) => {
    const { polygons } = this.state;
    const polygonChange = polygons.map(polygon => ({
      type: 'Polygon',
      coordinates: polygon.coordinates[0].map(coord => [coord.lng, coord.lat])
    }));

    this.handleEditChanged(coordinates, polygonChange, 'polygons', 'Polygon');
  };

  editPolygonLines = (coordinates) => {
    const { polygonLines } = this.state;
    const polygonLineChange = polygonLines.map(polygonLine => ({
      type: 'Polyline',
      coordinates: polygonLine.coordinates.map(coord => [coord.lng, coord.lat])
    }));
    this.handleEditChanged(coordinates, polygonLineChange, 'polylines', 'Polyline');
  }

  updateMarkers = (location) => {
    const { answer } = this.props;
    this.handleAnswerChanged(location, 'locations', 'Point');
    if (answer) {
      this.updateMapFromAnswer(answer);
    }
  };

  updatePolygons = (coordinates) => {
    const { answer } = this.props;

    if (coordinates.length > 0) {
      const first = coordinates[0];
      const last = coordinates[coordinates.length - 1];
      if (first[0] !== last[0] || first[1] !== last[1]) {
        coordinates.push([...first]);
      }
    }
    const polygon = {
      type: 'Polygon',
      coordinates: [coordinates]
    };
    this.handleAnswerChanged(polygon.coordinates[0], 'polygons', 'Polygon');
    if (answer) {
      this.updateMapFromAnswer(answer);
    }
  };

  updatePolyLine = (coordinates) => {
    const { answer } = this.props;
    this.handleAnswerChanged(coordinates, 'polylines', 'Polyline');
    if (answer) {
      this.updateMapFromAnswer(answer);
    }
  }

  removeMarker = (location, layerId) => {
    this.setState((prevState) => {
      const markers = prevState.markers.filter(marker => marker.id !== layerId);
      return { markers };
    });

    this.handleRemoveChanged(location, 'locations', 'Point', true);
  };

  removePolygon = (coordinates, layerId) => {
    this.setState((prevState) => {
      const polygons = prevState.polygons.filter(polygon => polygon.id !== layerId);
      return { polygons };
    });

    this.handleRemoveChanged(coordinates, 'polygons', 'Polygon', true);
  };

  removePolygonLine = (coordinates, layerId) => {
    this.setState((prevState) => {
      const polygonLines = prevState.polygonLines.filter(polygon => polygon.id !== layerId);
      return { polygonLines };
    });

    this.handleRemoveChanged(coordinates, 'polylines', 'Polyline', true);
  }

  updateMapFromAnswer = () => {
    const { answer, fromForms, allowMultiple } = this.props;
    if (!this.map || !answer) {
      this.drawnItems.clearLayers();
      return;
    }
    this.drawnItems.clearLayers();
    let reversedData = {};
    if (fromForms) {
      if (Object.values(answer)?.length > 0) {
        if (allowMultiple) {
          reversedData = {
            locations: answer?.locations?.map(loc => ({ type: loc.type, coordinates: this.handleMarkReverse(loc.coordinates) })) || [],

            polygons: answer?.polygons?.map(polygon => ({
              type: polygon.type,
              coordinates: Array.isArray(polygon.coordinates[0][0]) ? polygon.coordinates[0] : polygon.coordinates
            })) || [],

            polylines: Array.isArray(answer?.polylines) ? answer.polylines : answer?.polylines ? [answer.polylines] : []
          };
        } else if (Object.values(answer)?.length > 0) {
          reversedData = {
            locations: answer?.locations ? [{ type: 'Point', coordinates: this.handleMarkReverse(answer?.locations.coordinates) }] : [],
            polygons: answer?.polygons ? [{
              type: 'Polygon',
              coordinates: Array.isArray(answer?.polygons.coordinates[0])
                ? answer?.polygons.coordinates[0]
                : answer?.polygons.coordinates
            }] : [],
            polylines: answer?.polylines ? [answer?.polylines] : []
          };
        }
      }
    } else if (Object.values(answer)?.length > 0 && ((answer.locations && Object.values(answer.locations)?.length > 0)
      || (answer.polygons && Object.values(answer.polygons)?.length > 0))) {
      reversedData = {
        locations: answer?.locations?.map(location => ({
          type: location.type,
          coordinates: this.handleMarkReverse(location.coordinates)
        })) || [],
        polygons: answer?.polygons?.map(polygon => ({
          type: polygon.type,
          coordinates: polygon?.coordinates
        })) || []
      };
    }

    if (reversedData.locations?.length > 0) {
      const markersState = [];
      reversedData.locations.forEach((location) => {
        let marker = L.marker(location.coordinates, {
          icon: new L.Icon({
            iconUrl: icon,
            iconAnchor: [25, 35]
          })
        }).addTo(this.drawnItems);
        markersState.push({
          id: marker._leaflet_id,
          coordinates: [marker._latlng.lng, marker._latlng.lat]
        });
      });
      this.setState({
        markers: markersState
      });
    }

    if (reversedData.polylines?.length > 0) {
      const polygonsLineState = [];

      reversedData.polylines.forEach((polyline) => {
        const coordinates = polyline.coordinates.map(coord => this.handleMarkReverse(coord));
        let poly = L.polyline(coordinates, {
          color: fromForms ? '#3388ff' : 'blue',
          opacity: 1,
          fillOpacity: 0.48
        }).addTo(this.drawnItems);
        polygonsLineState.push({
          id: poly._leaflet_id,
          coordinates: poly._latlngs
        });
      });
      this.setState({
        polygonLines: polygonsLineState
      });
    }

    if (reversedData.polygons?.length > 0) {
      const polygonsState = [];

      reversedData.polygons.forEach((polygon) => {
        const coordinates = polygon.coordinates.map(coord => this.handleMarkReverse(coord));
        let poly = L.polygon(coordinates, {
          color: fromForms ? '#3388ff' : 'blue',
          opacity: 1,
          fillOpacity: 0.48
        }).addTo(this.drawnItems);
        polygonsState.push({
          id: poly._leaflet_id,
          coordinates: poly._latlngs
        });
      });
      this.setState({
        polygons: polygonsState
      });
    }
  };

  handleAnswerChanged = (value, fieldId, type) => {
    const { handleValueChange, handleFieldErrorChanged, isRequired, updateFieldErrors, answer, allowMultiple, fromForms } = this.props;

    if (fromForms) {
      let updatedValue;
      if (allowMultiple) {
        const existing = answer?.[fieldId] || [];
        if (type === 'Polygon') {
          updatedValue = [...existing, { type, coordinates: [value] }];
        } else if (type === 'Polyline') {
          updatedValue = [...existing, { type: 'LineString', coordinates: value }];
        } else {
          updatedValue = [...existing, { type, coordinates: value }];
        }
        handleValueChange(updatedValue, fieldId, type);
        let updatedErrors = [];
        if (
          !updatedValue
          || (Array.isArray(updatedValue) && updatedValue.length === 0)
        ) {
          handleFieldErrorChanged(fieldId, isRequired);
          updatedErrors.push('pulpoforms.errors.not_blank');
        } else {
          handleFieldErrorChanged(fieldId, false);
        }
        updateFieldErrors(updatedErrors);
      } else {
        handleValueChange(value, fieldId, type);
        let updatedErrors = [];

        if (value === '' || value === undefined) {
          handleFieldErrorChanged(fieldId, isRequired);
          updatedErrors = [...updatedErrors, 'pulpoforms.errors.not_blank'];
        } else {
          handleFieldErrorChanged(fieldId, false);
        }
        updateFieldErrors(updatedErrors);
      }
    } else {
      handleValueChange(value, fieldId, type);
      let updatedErrors = [];

      if (value === '' || value === undefined) {
        handleFieldErrorChanged(fieldId, isRequired);
        updatedErrors = [...updatedErrors, 'pulpoforms.errors.not_blank'];
      } else {
        handleFieldErrorChanged(fieldId, false);
      }
      updateFieldErrors(updatedErrors);
    }
  };

  handleRemoveChanged = (value, fieldId, type) => {
    const { handleValueRemove } = this.props;
    handleValueRemove(value, fieldId, type);
  };

  handleEditChanged = (value, previousValue, fieldId, type) => {
    const { handleValueEdit } = this.props;
    handleValueEdit(value, previousValue, fieldId, type);
  };

  addPopupToLayer = (layer) => {
    const { fromForms } = this.props;
    const customlayer = layer;
    customlayer.setStyle({
      fillColor: fromForms ? '#3388ff' : 'blue',
      opacity: 1,
      fillOpacity: 0.48
    });
    return customlayer;
  };

  render() {
    const { detailsFrom, onlyLocationView, printMap } = this.props;
    return <div
      id={this.ID}
      ref={this.mapContainerRef}
      className={onlyLocationView ? fstyles.map : styles.map}
      style={{ height: detailsFrom && '430px', width: printMap && '1000px' }}
    />;
  }
}

MultiLocation.propTypes = {
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired,
  answer: PropTypes.arrayOf(PropTypes.number),
  locationChanged: PropTypes.bool,
  changeLocationChangedStatus: PropTypes.func
};

MultiLocation.defaultProps = {
  answer: undefined,
  locationChanged: false,
  changeLocationChangedStatus: () => { }
};

export default MultiLocation;
